import { IDiscordMessage } from "#api/discord";
import { Embed } from "./embed";
import { Markdown } from "./markdown";
import { Attachments } from "./attachments";
import { useState } from "react";
import { DropdownMenu } from "radix-ui";

import * as styles from "./styles.module.scss";

interface IProps {
  message: IDiscordMessage;
}

export function Message({ message }: IProps) {
  const [renderedMessage, setRenderedMessage] = useState<Omit<IDiscordMessage, "revisions">>(message);
  const [msgKey, setMsgKey] = useState(message.edited || message.published);
  const revisions = message.revisions.length ? [{ key: message.edited || message.published, label: "Current", onClick: () => setRenderedMessage(message) }]
    .concat(message.revisions.map(revision => {
      return {
        key: revision.edited || revision.published,
        label: revision.edited || revision.published,
        onClick: () => setRenderedMessage(revision),
      };
  })) : [];

  return (
    <li key={renderedMessage.id} id={`message-${renderedMessage.id}`}>
      <Markdown text={renderedMessage.content} />
      {message.revisions.length ? (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <span className={styles.edited}> ({message.revisions.length} {message.revisions.length == 1 ? "edit" : "edits"})</span>
          </DropdownMenu.Trigger>

          <DropdownMenu.Portal>
            <DropdownMenu.Content className={styles.dropdown}>
              <DropdownMenu.RadioGroup value={msgKey} onValueChange={setMsgKey}>
                {revisions.map(revision => (
                  <DropdownMenu.RadioItem className={styles.dropdownItem} value={revision.key} onClick={revision.onClick}>
                    <DropdownMenu.ItemIndicator className={styles.indicator}>
                      ✓
                    </DropdownMenu.ItemIndicator>
                    <span>{revision.label}</span>
                  </DropdownMenu.RadioItem>
                ))}
              </DropdownMenu.RadioGroup>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      ) : undefined}

      {renderedMessage.embeds.map(embed => (
        <Embed embed={embed} />
      ))}

      <Attachments attachments={renderedMessage.attachments} />
    </li>
  );
}
